// extracted by mini-css-extract-plugin
export default {"root":"EmployedsList_root__y+iTM","root_nothing":"EmployedsList_root_nothing__iVwlj","window":"EmployedsList_window__gU9il"};